import CardWrapper from '../wrapper/card';
import { Edit } from '@mui/icons-material';
import LabelWrapper from '../wrapper/label';
import RenderIcons from '../reusable/render_icons';
import { settingEditClientFlag } from '../../redux/slices/client';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const ClientDetailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedClientsDeal } = useSelector((state: RootState) => state.deal);
    const { selectedClient } = useSelector((state: RootState) => state.client);

    const editDealFlag = () => {
        dispatch(settingEditClientFlag(true));
    };

    return (
        <CardWrapper flex={selectedClient?.company_type === 'company' ? 4 : 1} minHeight="250px">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box></Box>
                <Typography color="textSecondary" align="center" variant="h5" my={1}>{selectedClient?.company_name}</Typography>
                <IconButton onClick={editDealFlag}>
                    <Edit />
                </IconButton>
            </Box>
            <Divider />
            <LabelWrapper label="DETAILS" mt={1} />
            <Typography variant="body2" color="textSecondary" my={1}><b>Email:</b> {selectedClient?.company_email ? selectedClient?.company_email : 'Email not available'}</Typography>
            <Typography variant="body2" color="textSecondary"><b>Location: </b>
            {!selectedClient?.address && !selectedClient?.city && !selectedClient?.state && !selectedClient?.zip
                ? 'Location not available'
                : `${selectedClient?.address || ''} ${selectedClient?.city || ''}, ${selectedClient?.state || ''} ${selectedClient?.zip || ''}`}
            </Typography>
            <Typography variant="body2" color="textSecondary" my={1}><b>Contact:</b> {selectedClient?.contact_number ? selectedClient.contact_number : 'Contact not available'}</Typography>
            <Box>
                <RenderIcons contacts={selectedClientsDeal?.prospect_result_meta || []} />
            </Box>
        </CardWrapper>
    );
};

export default ClientDetailComponent;